import EffortsTableWithFilters from 'pages/efforts/EffortsTable';
import { GroupMemberRoleType, PartyGroup } from 'types/groups';

interface Props {
    partyGroup: PartyGroup;
}

const EffortsView: React.FC<Props> = ({ partyGroup }) => {
    let partyIds = partyGroup.parties
        ?.filter((item) => item.groupMemberRoleTypeCode === GroupMemberRoleType.MEMBER)
        .map((item) => item.party.id);
    if (!partyIds || partyIds.length === 0) {
        partyIds = [0];
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <EffortsTableWithFilters passiveFilter={`parties.party.id=in=(${partyIds.join(',')})`} />
        </div>
    );
};

export default EffortsView;
